import { createModalHook } from '@change-corgi/design-system-legacy/modals';

import type { PreviewModalProps } from '../../../../types';
import { PreviewEmailModalBody } from '../../components/PreviewEmailModalBody';

export const usePreviewModal = createModalHook<PreviewModalProps>({
	name: 'PetitionUpdateCreatePreviewModal',
	closeButton: false,
	body: function PetitionUpdateCreatePreviewModalBody({ options, closeModal }) {
		return <PreviewEmailModalBody {...options} onClose={closeModal} />;
	},
	stylesOverrides: {
		width: [null, 620],
		paddingX: [16, 24],
	},
});
